import { duration } from '../utils/duration';

export type LimitID = 'capped';
export type Limit = { count: number; interval: number };

const limits: Record<LimitID, Limit> = {
  capped: { count: 3, interval: duration({ hours: 6 }) },
};

export default {
  limits,
  maxStorageInterval: duration({ hours: 72 }),
  adContinueMoves: [1, 2, 2],
  allowListedAdContinueProbability: 0.5,
  purchaseThreshold: duration({ days: 90 }),
};
